export class FlatRate {
  numberOfFlatRates: number;
  chosenType: string;
  monthlyCost: number;
  fixnetMinutes: number;
  fixnetMobileMinutes: number;
  editable: boolean;
  unitMonthlyCost: number;

  constructor() {
    this.numberOfFlatRates = 0;
    this.chosenType = '';
    this.fixnetMinutes = 0;
    this.fixnetMobileMinutes = 0;
    this.editable = true;
    this.unitMonthlyCost = 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/FlatRate.ts